import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])

export const pageSearch = {
  'region': {
    title: '省份',
    type: 'select',
    equation: city,
    dictionary: 'region'
  },
  'city': {
    describe: true,
    title: '城市',
    type: 'select',
    equation: city,
    dictionary: 'city'
  },
  'customer': {
    title: '经销商',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '经销商选择'
    }
  },
  'brand_bq': {
    title: '品牌',
    type: 'select',
    equation: city,
    dictionary: 'A0018'
  },
  'cust_name': {
    title: '计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0002'
  },
  'customer_type': {
    title: '年份',
    equation: city,
    type: 'year'
  }
}

export default {
  'saleCenter': { title: '营销中心' },
  'saleCenter1': { title: '省份' },
  'saleCenter2': { title: '计划类型' },
  'saleCenter3': { title: '产品分类' },
  'saleCenter4': { title: '1月原计划量' },
  'saleCenter5': { title: '1月调整量' },
  'saleCenter6': { title: '2月原计划量' },
  'saleCenter7': { title: '2月调整量' },
  'saleCenter8': { title: '3月原计划量' },
  'saleCenter9': { title: '3月调整量' },
  'saleCenter10': { title: '4月原计划量' },
  'saleCenter11': { title: '4月调整量' },
  'saleCenter12': { title: '5月原计划量' },
  'saleCenter13': { title: '5月调整量' },
  'saleCenter14': { title: '6月原计划量' },
  'saleCenter15': { title: '6月调整量' },
  'saleCenter16': { title: '7月原计划量' },
  'saleCenter17': { title: '7月调整量' },
  'saleCenter18': { title: '8月原计划量' },
  'saleCenter19': { title: '8月调整量' },
  'saleCenter20': { title: '9月原计划量' },
  'saleCenter21': { title: '9月调整量' },
  'saleCenter22': { title: '10月原计划量' },
  'saleCenter23': { title: '10月调整量' },
  'saleCenter24': { title: '11月原计划量' },
  'saleCenter25': { title: '11月调整量' },
  'saleCenter26': { title: '12月原计划量' },
  'saleCenter27': { title: '12月调整量' }
}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/deliveryPlanStatisticsReportForms.js